import { LANGUAGE_PICKER_BODY, LANGUAGE_PICKER_TITLES } from '@hero/agent';
import type { Language } from '@hero/schema';
import { Button } from '../../../../ui/Button/Button';
import { useAgentChatManager } from '../useAgentChatManager';

export interface LanguagePickerWidgetProps {
  options: Language[];
}

/**
 * "Which language?" — copy is trilingual by design (the thread has no
 * language yet), so it comes from `@hero/agent`, not i18n. A tap sends
 * the option title, which the backend reads as an explicit choice.
 */
export const LanguagePickerWidget = ({ options }: LanguagePickerWidgetProps) => {
  const manager = useAgentChatManager();
  return (
    <div className='flex flex-col gap-2'>
      <p className='text-sm text-slate-700'>{LANGUAGE_PICKER_BODY}</p>
      <div className='flex flex-wrap gap-2'>
        {options.map(language => (
          <Button
            key={language}
            size='sm'
            variant='outline'
            dir={language === 'en' ? 'ltr' : 'rtl'}
            onClick={() => manager.sendMessage(LANGUAGE_PICKER_TITLES[language])}
          >
            {LANGUAGE_PICKER_TITLES[language]}
          </Button>
        ))}
      </div>
    </div>
  );
};
